import React, { useState } from 'react'

import { FilterPill } from '../FilterPill'
import { FilterTypePopup } from './FilterTypePopup'
import { FilterDropdownOptions } from './FilterDropdownOptions'

export const FilterTypeDropdown = ({
  schema = {},
  value,
  loading,
  updateSearch,
  showAllOnEmpty = false,
  showAllOnEmptyLabel = null,
  showLabel = true,
  isClearable = false,
  customFilterIcon,
  ...props
}) => {
  const [open, setOpen] = useState(false)
  const options = schema.options || []
  const optionSets = [{ accessor: schema.accessor, options, selectedValue: value }]

  return (
    <FilterTypePopup
      open={open}
      setOpen={setOpen}
      position="bottom left"
      className="filter-pill__popup--medium"
      trigger={
        <FilterPill
          {...props}
          showAllOnEmpty={showAllOnEmpty}
          showAllOnEmptyLabel={showAllOnEmptyLabel}
          clickable
          isClearable={isClearable}
          loading={loading}
          label={schema.label}
          value={options.find((option) => option.value === value)?.label}
          showLabel={showLabel}
          active={open}
          customFilterIcon={customFilterIcon}
          handleRemoveFilter={(event) => {
            event.stopPropagation()

            updateSearch(schema.accessor, '')
            setOpen(false)
          }}
        />
      }
    >
      <FilterDropdownOptions
        optionSets={optionSets}
        handleChange={(accessor, value) => {
          updateSearch(accessor, value)
          setOpen(false)
        }}
        isClearable={isClearable}
      />
    </FilterTypePopup>
  )
}
